import React from 'react';
import { BrowserRouter as Router, Routes as RouterRoutes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import RoutesPage from './pages/Routes';
import Tickets from './pages/Tickets';
import Fleet from './pages/Fleet';
import Pricing from './pages/Pricing';
import Support from './pages/Support';
import Blog from './pages/Blog';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import GDPR from './pages/GDPR';
import Cookies from './pages/Cookies';
import FonduriEuropene from './pages/FonduriEuropene';
import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <RouterRoutes>
          <Route path="/" element={<Home />} />
          <Route path="/rute" element={<RoutesPage />} />
          <Route path="/bilete" element={<Tickets />} />
          <Route path="/flota" element={<Fleet />} />
          <Route path="/tarife" element={<Pricing />} />
          <Route path="/suport" element={<Support />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/termeni" element={<Terms />} />
          <Route path="/confidentialitate" element={<Privacy />} />
          <Route path="/gdpr" element={<GDPR />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/fonduri-europene" element={<FonduriEuropene />} />
        </RouterRoutes>
      </Layout>
    </Router>
  );
}

export default App;
